import src from "IMAGE";
export default { src, width: 465, height: 488, blurWidth: 0, blurHeight: 0};
